/**
 * Countries list in Italian
 * Excludes US-sanctioned countries: Cuba, Iran, North Korea, Syria, Russia, Belarus
 */

import { Country } from './countries_en';

export const countries_it: Country[] = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua e Barbuda' },
  { code: 'SA', name: 'Arabia Saudita' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaigian' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrein' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BE', name: 'Belgio' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia ed Erzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brasile' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambogia' },
  { code: 'CM', name: 'Camerun' },
  { code: 'CA', name: 'Canada' },
  { code: 'CV', name: 'Capo Verde' },
  { code: 'TD', name: 'Ciad' },
  { code: 'CL', name: 'Cile' },
  { code: 'CN', name: 'Cina' },
  { code: 'CY', name: 'Cipro' },
  { code: 'VA', name: 'Città del Vaticano' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comore' },
  { code: 'CG', name: 'Congo' },
  { code: 'CD', name: 'Congo (Repubblica Democratica)' },
  { code: 'KR', name: 'Corea del Sud' },
  { code: 'CI', name: 'Costa d\'Avorio' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croazia' },
  { code: 'DK', name: 'Danimarca' },
  { code: 'DM', name: 'Dominica' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egitto' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'AE', name: 'Emirati Arabi Uniti' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Etiopia' },
  { code: 'FJ', name: 'Figi' },
  { code: 'PH', name: 'Filippine' },
  { code: 'FI', name: 'Finlandia' },
  { code: 'FR', name: 'Francia' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germania' },
  { code: 'GH', name: 'Ghana' },
  { code: 'JM', name: 'Giamaica' },
  { code: 'JP', name: 'Giappone' },
  { code: 'DJ', name: 'Gibuti' },
  { code: 'JO', name: 'Giordania' },
  { code: 'GR', name: 'Grecia' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GQ', name: 'Guinea Equatoriale' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Irlanda' },
  { code: 'IS', name: 'Islanda' },
  { code: 'MH', name: 'Isole Marshall' },
  { code: 'SB', name: 'Isole Salomone' },
  { code: 'IL', name: 'Israele' },
  { code: 'IT', name: 'Italia' },
  { code: 'KZ', name: 'Kazakistan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KG', name: 'Kirghizistan' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'LA', name: 'Laos' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LV', name: 'Lettonia' },
  { code: 'LB', name: 'Libano' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libia' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lituania' },
  { code: 'LU', name: 'Lussemburgo' },
  { code: 'MK', name: 'Macedonia del Nord' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldive' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MA', name: 'Marocco' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Messico' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'MD', name: 'Moldavia' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MZ', name: 'Mozambico' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NO', name: 'Norvegia' },
  { code: 'NZ', name: 'Nuova Zelanda' },
  { code: 'OM', name: 'Oman' },
  { code: 'NL', name: 'Paesi Bassi' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PS', name: 'Palestina' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua Nuova Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Perù' },
  { code: 'PL', name: 'Polonia' },
  { code: 'PT', name: 'Portogallo' },
  { code: 'QA', name: 'Qatar' },
  { code: 'GB', name: 'Regno Unito' },
  { code: 'CF', name: 'Repubblica Centrafricana' },
  { code: 'CZ', name: 'Repubblica Ceca' },
  { code: 'DO', name: 'Repubblica Dominicana' },
  { code: 'RO', name: 'Romania' },
  { code: 'RW', name: 'Ruanda' },
  { code: 'KN', name: 'Saint Kitts e Nevis' },
  { code: 'VC', name: 'Saint Vincent e Grenadine' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'LC', name: 'Santa Lucia' },
  { code: 'ST', name: 'São Tomé e Príncipe' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovacchia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ES', name: 'Spagna' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'US', name: 'Stati Uniti' },
  { code: 'ZA', name: 'Sudafrica' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SS', name: 'Sudan del Sud' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SE', name: 'Svezia' },
  { code: 'CH', name: 'Svizzera' },
  { code: 'TJ', name: 'Tagikistan' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailandia' },
  { code: 'TL', name: 'Timor Est' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad e Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turchia' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UA', name: 'Ucraina' },
  { code: 'UG', name: 'Uganda' },
  { code: 'HU', name: 'Ungheria' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' }
];
